<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <users-crud></users-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UsersCrud from './users/UsersCrud';

    export default {

        components: {
            UsersCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.users'),
                    },
                ]
            }
        },
    }
</script>
